import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Package } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { sectors } from '../data/sectors';
import { products } from '../data/products';
import { ProductPlaceholder } from '../components/ProductPlaceholder';
export function SectorsHubPage() {
  return <>
      <PageHero label="Manufacturing" title="Our Markets" subtitle="Chiltern Global provides specialist manufacturing support to four core sectors, delivering compliant, specification-grade equipment to defence, police, prison, and medical organisations." data-id="element-1323" />

      <section className="bg-white py-24" data-id="element-1324">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1325">
          <div className="grid grid-cols-1 gap-20" data-id="element-1326">
            {sectors.map(sector => {
            // Get 3 products for this sector
            const sectorProducts = products.filter(p => p.sectors.includes(sector.slug)).slice(0, 3);
            return <div key={sector.slug} id={sector.slug} className="flex flex-col lg:flex-row gap-12 border-b border-steel-100 pb-20 last:border-0 last:pb-0 scroll-mt-32" data-id="element-1327">
                  {/* Sector Info - Navy Panel Style */}
                  <div className="lg:w-1/3" data-id="element-1328">
                    <div className="aspect-video bg-navy-900 rounded-sm overflow-hidden mb-6 flex items-center justify-center p-8 relative group" data-id="element-1329">
                      <img src={sector.image} alt={sector.name} className="absolute inset-0 w-full h-full object-cover opacity-40 group-hover:opacity-50 transition-opacity" data-id="element-1330" />
                      <h3 className="text-3xl font-bold text-white text-center relative z-10" data-id="element-1331">
                        {sector.name}
                      </h3>
                    </div>
                    <h2 className="text-3xl font-bold text-navy-900 mb-4" data-id="element-1332">
                      {sector.name}
                    </h2>
                    <p className="text-steel-600 mb-6 leading-relaxed" data-id="element-1333">
                      {sector.shortDescription}
                    </p>
                    <Link to={`/manufacturing/markets/${sector.slug}`} className="inline-flex items-center justify-center px-6 py-3 bg-navy-900 text-white font-bold uppercase tracking-wider text-sm rounded-sm hover:bg-cg-orange-600 transition-colors" data-id="element-1334">
                      View Sector Profile
                    </Link>
                  </div>

                  {/* Recommended Products */}
                  <div className="lg:w-2/3" data-id="element-1335">
                    <h3 className="text-sm font-bold text-navy-900 uppercase tracking-wider mb-6 flex items-center gap-2" data-id="element-1336">
                      <Package className="w-4 h-4 text-cg-orange-600" data-id="element-1337" />{' '}
                      Recommended Equipment
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1338">
                      {sectorProducts.map(product => <Link key={product.slug} to={`/products/${product.slug}`} className="group bg-slate-50 border border-steel-200 hover:border-cg-orange-600 transition-colors" data-id="element-1339">
                          <div className="aspect-square overflow-hidden bg-white relative" data-id="element-1340">
                            <ProductPlaceholder aspectRatio="1/1" className="w-full h-full" data-id="element-1341" />
                          </div>
                          <div className="p-4" data-id="element-1342">
                            <h4 className="text-sm font-bold text-navy-900 mb-1 group-hover:text-cg-orange-600 transition-colors line-clamp-1" data-id="element-1343">
                              {product.name}
                            </h4>
                            <p className="text-xs text-steel-500 line-clamp-2 mb-3" data-id="element-1344">
                              {product.shortDescription}
                            </p>
                            <span className="text-[10px] font-bold text-navy-900 uppercase tracking-wider flex items-center gap-1" data-id="element-1345">
                              View Spec{' '}
                              <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-1346" />
                            </span>
                          </div>
                        </Link>)}
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </section>

      <section className="bg-navy-900 py-20" data-id="element-1347">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1348">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1349">
            Discuss a Sector Requirement
          </h2>
          <p className="text-steel-300 max-w-2xl mx-auto mb-10 text-lg" data-id="element-1350">
            Our procurement team is ready to discuss your specific sector needs,
            compliance requirements, and volume manufacturing capabilities.
          </p>
          <Link to="/contact" className="inline-flex items-center justify-center px-10 py-4 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors" data-id="element-1351">
            Contact Procurement Team
          </Link>
        </div>
      </section>
    </>;
}